<template>
  <section class="feature" name="feature">
    <div class="container">
      <a-typography-title :level="1"
                          data-aos="fade-down">
        Featured products drive higher business value
      </a-typography-title>
      <a-tabs v-model:activeKey="tab.active"
              data-aos="fade-up" centered>
        <a-tab-pane v-for="(item,index) in tab.list"
                    :key="index+1" :tab="item.title">
          <a-row :class="[`t_${index+1}`,tab.show===index+1?'tab_show':'']">
            <a-col :xs="24" :lg="14">
              <div class="item" :class="`i_${index+1}`">
                <a-typography-title v-if="item.title" :level="5">
                  {{ item.title }}
                </a-typography-title>
                <a-typography-paragraph>
                  {{ item.text }}
                </a-typography-paragraph>
              </div>
            </a-col>
            <a-col :xs="0" :lg="10">
              <div class="media" :class="`m_${index+1}`" />
            </a-col>
          </a-row>
        </a-tab-pane>
      </a-tabs>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'home_feature',
  data(): DataInterface {
    return {
      tab: {
        active: 1,
        show: 1,
        list: [
          {
            title: 'AIPilot',
            text: 'The next-generation AI application platform driven by Serverless technology - AIPilot, ' +
                  'easily manages the ever-growing number of AI applications and large models, ' +
                  'unifying the scheduling of cloud and local GPU, CPU, and other computing resources. ' +
                  'AIPilot supports large-scale model inference and has connected with more than eight major model APIs, ' +
                  'helping enterprises quickly, efficiently, and cost-effectively integrate AI into diverse production scenarios. ' +
                  'Based on numerous patented technologies, AIPilot can deploy 20 popular AI applications on a single 8-core 16G laptop, ' +
                  'allowing you to build a dedicated AI application engine. '
          },
          {
            title: 'InfraPilot',
            text: 'InfraPilot, the future AI hosting platform of Galaxy-Future, ' +
                  'relies on multiple patented technologies to achieve Serverless AI applications and large model inference without modification. ' +
                  'InfraPilot supports minute-level application deployment, GPU/CPU automatic scheduling, unmanned operation and maintenance, and automated cost management. ' +
                  'It provides one-stop management of various self-developed AI applications and large models within the enterprise, ' +
                  'builds an efficient AI application development and large model training inference platform, and significantly improves R & D efficiency.'
          }
        ]
      },
    };
  },
  watch: {
    'tab.active': {
      async handler(newData: any, oldDate: any): Promise<any> {
        await $FN.WaitTime(50);
        this.tab.show = newData;
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}overseas/home/';

.creatAnimation(am_feature, {
  0% {
    .transform(translate(-50%, -50%));
  }
  50% {
    .transform(translate(-50%, calc(~'-50% - 10px')));
  }
  100% {
    .transform(translate(-50%, -50%));
  }
});

.feature {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background-color: @color_white;
  
  .container {
    position: relative;
    z-index: 1;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

.ant-tabs {
  overflow: initial;
  margin: @margin_mo 0 0;
  
  &:deep(.ant-tabs-nav) {
    &::before {
      display: none;
    }
    
    .ant-tabs-nav-list {
      @wh: 30px;
      @scale: 0.7;
      position: relative;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, auto, 0, 1px, 50%);
        z-index: 0;
        width: 200%;
        border-bottom: none;
        .transform(translateX(-50%) scale(0.5));
      }
      
      .ant-tabs-tab {
        &:nth-child(1) {
          .ant-tabs-tab-btn::before {
            background-position-x: 0;
          }
        }
        
        &:nth-child(2) {
          .ant-tabs-tab-btn::before {
            background-position-x: -@wh*@scale;
          }
        }
        
        .ant-tabs-tab-btn {
          padding: 0 100px;
          
          &::before {
            content: '';
            display: inline-block;
            width: @wh*@scale;
            height: @wh*@scale;
            margin: 0 5px 0 0;
            .bg('@{image}feature_icon.png', @wh*@scale*2, @wh*@scale);
            vertical-align: top;
          }
        }
      }
      
      .ant-tabs-ink-bar {
        height: 3px;
      }
    }
    
    .ant-tabs-tab {
      padding: 20px 0;
      .font(center, @text_big, @color_12, @text_big, true);
      
      &.ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: @color_6;
        }
      }
    }
    
    .ant-tabs-ink-bar {
      background-color: @color_6;
    }
  }
  
  &:deep(.ant-tabs-content) {
    .ant-tabs-tabpane {
      .tab_show {
        .item,
        .media {
          opacity: 1;
          .transform(translate(0, 0));
        }
      }
      
      .item {
        .transform(translate(-100px, 0));
      }
      
      .media {
        .transform(translate(100px, 0));
      }
      
      .item,
      .media {
        @aTime: 1s;
        @style: transform @aTime, opacity @aTime;
        opacity: 0;
        .transition(@style);
      }
    }
  }
}

.ant-row {
  overflow: hidden;
  background-size: cover !important;
  border-radius: 8px;
  
  .loop(@i) when (@i<=2) {
    &.t_@{i} {
      .bg('@{image}feature_bg_@{i}.jpg');
    }
    .loop(@i+1);
  }
  .loop(1);
  
  .ant-col {
    &:nth-child(1) {
      z-index: 1;
    }
    
    &:nth-child(2) {
      z-index: 0;
    }
  }
}

.item {
  position: relative;
  padding: 50px;
  
  h5.ant-typography {
    margin: 0;
    .font(left, @title_sub, @color_white, @title_sub, true);
  }
  
  div.ant-typography {
    margin: @margin_mo 0 0;
    .font(left, @text+@line, @color_white, @text);
    
    &:nth-child(2) {
      margin: 20px 0 0;
    }
    
    p {
      margin: @margin_mo 0 0;
    }
    
    span {
      display: block;
      position: relative;
      padding-left: 15px;
      margin: 5px 0 0;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 10px, auto, auto, 0);
        width: 5px;
        height: 5px;
        margin: auto 0;
        border-radius: 4px;
        background-color: @color_white;
      }
    }
  }
}

.media {
  @scale: 0.7;
  position: relative;
  height: 100%;
  
  &.m_1 {
    &::before {
      .bg('@{image}feature_image_1.png', 589px*@scale, 365px*@scale, true);
    }
  }
  
  &.m_2 {
    &::before {
      .bg('@{image}feature_image_2.png', 533px*@scale, 312px*@scale, true);
    }
  }
  
  &::before {
    content: '';
    display: block;
    .center();
    .animation(am_feature 5s ease infinite forwards);
  }
}

@media screen and (max-width: -1px+@grid_lg) {
  .ant-tabs {
    &:deep(.ant-tabs-content) {
      .ant-tabs-tabpane {
        .item {
          @aTime: 1s;
          @dTime: 0.2s;
          @style: transform @aTime @dTime, opacity @aTime @dTime;
          .transform(translate(0, 50px));
          .transition(@style);
        }
      }
    }
  }
  
  .item {
    position: relative;
    height: auto;
    
    div.ant-typography {
      height: auto;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .engine {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-tabs {
    &:deep(.ant-tabs-nav) {
      .ant-tabs-nav-list {
        @wh: 30px;
        @scale: 0.5;
        
        .ant-tabs-tab {
          &:nth-child(1) {
            .ant-tabs-tab-btn::before {
              background-position-x: 0;
            }
          }
          
          &:nth-child(2) {
            .ant-tabs-tab-btn::before {
              background-position-x: -@wh*@scale;
            }
          }
          
          .ant-tabs-tab-btn {
            padding: 0 @margin_mo;
            
            &::before {
              width: @wh*@scale;
              height: @wh*@scale;
              margin: 5px 5px 0 0;
              .bg('@{image}feature_icon.png', @wh*@scale*2, @wh*@scale);
            }
          }
        }
      }
      
      .ant-tabs-tab {
        padding: 10px 0;
        .font(center, @font_7+@line, @color_12, @font_7, true);
        
        &.ant-tabs-tab-active {
          .ant-tabs-tab-btn {
            color: @color_6;
          }
        }
      }
    }
  }
  
  .item {
    min-height: 330px;
    padding: 20px;
    
    h5.ant-typography {
      .font(left, @title_sub_mo, @color_white, @title_sub_mo, true);
    }
    
    div.ant-typography {
      .font(left, @text_mo+@line_mo, @color_white, @text_mo);
    }
  }
}
</style>